import styled from "styled-components";

export const Description = styled.span`
    margin-right:5px;
    font: Normal 13px/16px Roboto;
    color: #262626;
`;
